// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Stack, Text } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { useListState } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';
import Moment from 'react-moment';
import { RoutingS } from '../../../Service/RoutingS';
import PanePaper from '../../../Molecules/PanePaper';
import { QuestionnaireTemplateDto } from '../../../Types/QuestionnaireT';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import { LicenceS } from '../../../Service/LicenceS';
import SkeletonItems from '../../../Atoms/SkeletonItems';
import { QuestionnaireTemplateS } from '../../../Service/QuestionnaireTemplateS';
import QuestionnaireTemplateActions from './QuestionnaireTemplateActions';
import { openCreateQuestionnaireTemplateModal } from './Modals';

const QuestionnaireTemplateList = () => {
  const [loading, setLoading] = useState(false);
  const [templates, handlers] = useListState<QuestionnaireTemplateDto>([]);
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const navigate = useNavigate();
  const { setState } = handlers;

  useEffect(() => {
    RoutingS.changeTitle('Fragebogen-Vorlagen');
    setLoading(true);
    QuestionnaireTemplateS.fetchTemplates()
      .then(setState)
      .finally(() => setLoading(false));
  }, [setState]);

  const createTemplate = () => {
    executeWithLicenceCheck(LicenceS.Restrictions.FRAGEBOGEN_USAGE, () =>
      openCreateQuestionnaireTemplateModal({ existingNames: templates.map((t) => t.name) }),
    );
  };

  const mapListItemUI = (template: QuestionnaireTemplateDto, idx: number) => {
    const { name, lastModified } = template;
    return (
      <Group position="apart">
        <Stack spacing={0}>
          <Text
            size="md"
            sx={{ cursor: 'pointer', color: 'black' }}
            variant="link"
            onClick={() => navigate(`/settings/template/questionnaire/${name}`)}
          >
            {name}
          </Text>
          <Text size="xs" color="dimmed">
            Bearbeitet{'  '}
            <Moment fromNow date={lastModified} />
          </Text>
        </Stack>
        <div>
          <QuestionnaireTemplateActions index={idx} template={template} handlers={handlers} />
        </div>
      </Group>
    );
  };

  return (
    <PanePaper
      title="questionnaire.templates"
      tooltip="help.settings.questionnaire.templates.pane"
      rightSection={<BookitupAddIcon onClick={createTemplate} />}
      sx={{ maxWidth: 500 }}
    >
      {loading && <SkeletonItems height={50} />}
      {!loading && templates.length === 0 && (
        <Text italic color="dimmed" size="xs" weight="lighter">
          Noch nichts hinzugefügt.
        </Text>
      )}
      {templates.length > 0 && <Stack mt="md">{templates.map(mapListItemUI)}</Stack>}
    </PanePaper>
  );
};

export default QuestionnaireTemplateList;
